// extracted by mini-css-extract-plugin
export default {"alert":"AlertBox_alert__sQYCf","info":"AlertBox_info__mnipO","warning":"AlertBox_warning__jz3L4","success":"AlertBox_success__IO4OV","danger":"AlertBox_danger__m8+fu"};